import Swiper, {
    Autoplay,
    Controller,
    EffectCreative,
    EffectFade,
    Grid,
    Mousewheel,
    Navigation,
    Pagination,
    Thumbs
} from 'swiper';

Swiper.use([Controller, EffectCreative, EffectFade, Grid, Mousewheel, Navigation, Pagination, Thumbs, Autoplay]);

class SwiperSlider {
    constructor(options) {
        this.item = options.item;
        this.slider = null;
        this.settings = options.settings;
    }

    init() {
        this.slider = new Swiper(this.item, this.settings);
    }

    destroy() {
        if (!this.slider) {
            return;
        }

        this.slider.destroy();
        this.slider = null;
    }
}

export default SwiperSlider;
